import { useEffect, useState } from 'react';

import api from '../service/api';
import { parseJSON } from '../util';
import PopupDialog from './PopupDialog';
import WelcomeCarousel, { fileSrc } from './WelcomeCarousel';

const testImage = (label, color) => `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="800" height="450" viewBox="0 0 800 450">
    <rect width="800" height="450" fill="${color}"/>
    <text x="400" y="245" font-family="sans-serif" font-size="72" fill="#fff" text-anchor="middle">${label}</text>
  </svg>`,
)}`;
const TEST_IMAGES = [testImage('Test 1', '#4f46e5'), testImage('Test 2', '#059669'), testImage('Test 3', '#dc2626')];

const preloadImages = (files) => Promise.all(files.map((file) => {
  const img = new Image();
  img.src = fileSrc(file);

  if (typeof img.decode === 'function') return img.decode().catch(() => {});

  return new Promise((resolve) => {
    img.onload = resolve;
    img.onerror = resolve;
  });
}));

const welcomeEnabled = !!(+document.querySelector('meta[name="portal-welcome"]')?.content);

const WelcomeModalContent = ({ test = false }) => {
  const [files, setFiles] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;

    api.getWelcome()
      .then((resp) => {
        if (resp?.data?.status != 0) return [];

        const dane = resp.data.dane;
        const list = Array.isArray(dane) ? dane : parseJSON(dane);
        if (!Array.isArray(list)) return [];

        return list.map((el) => el?.repo_id).filter(Boolean);
      })
      .catch(() => [])
      .then(async (guids) => {
        const list = test ? [...guids, ...TEST_IMAGES] : guids;

        await preloadImages(list);
        if (!isMounted) return;
        setFiles(list);
        setLoaded(true);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <PopupDialog
      cookieName="global-welcome-dialog"
      hash={files.map((file) => (file.startsWith('data:') ? 'test' : file)).join(',')}
      enable={loaded && files.length > 0}
      staleTime={test ? 0 : 20}
      content={<WelcomeCarousel files={files} />}
    />
  );
};

const WelcomeModal = ({ test = false }) => (welcomeEnabled ? <WelcomeModalContent test={test} /> : null);

export default WelcomeModal;
